/**
 * QR Code generation utility.
 * Generates an SVG QR code for a given URL with embedded session code.
 */

import qrcode from 'qrcode-generator';

/**
 * Generate an SVG QR code for joining a game session.
 * @param sessionCode - The 4-digit session code
 * @returns SVG string of the QR code
 */
export function generateJoinQrCode(sessionCode: string): string {
  const baseUrl = window.location.origin + window.location.pathname;
  const joinUrl = `${baseUrl}?join=${sessionCode}`;

  const qr = qrcode(0, 'M'); // type 0 = auto-detect size, error correction M
  qr.addData(joinUrl);
  qr.make();

  return qr.createSvgTag({ scalable: true, margin: 2 });
}

/**
 * Get the join URL for a session (for display or sharing).
 */
export function getJoinUrl(sessionCode: string): string {
  const baseUrl = window.location.origin + window.location.pathname;
  return `${baseUrl}?join=${sessionCode}`;
}
